var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#B5B510",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3535_319)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3535_319",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H8V26H26V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3535_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7777 16.9056L25.0288 22.5198C25.1988 22.6229 25.4202 22.5688 25.5234 22.3988C25.6265 22.2289 25.5724 22.0075 25.4024 21.9043L16.1513 16.2901C15.9813 16.1869 15.7599 16.2411 15.6568 16.411C15.5536 16.5811 15.6078 16.8025 15.7777 16.9056Z",
    fill: "#B5B510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2905 16.7259C17.5147 15.1682 20.1478 14.922 22.4045 16.225C24.7418 17.5743 25.831 20.0936 24.9507 21.9457C24.8654 22.1252 24.9418 22.34 25.1213 22.4253C25.3009 22.5107 25.5157 22.4343 25.601 22.2547C26.6583 20.03 25.402 17.1241 22.7645 15.6014C20.2201 14.1324 17.1904 14.4156 15.7244 16.281C15.6016 16.4373 15.6287 16.6637 15.785 16.7865C15.9414 16.9094 16.1677 16.8822 16.2905 16.7259Z",
    fill: "#B5B510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7218 12.1892C13.7218 11.3777 13.064 10.7199 12.2525 10.7199C11.441 10.7199 10.7832 11.3777 10.7832 12.1892C10.7832 13.0007 11.441 13.6585 12.2525 13.6585C13.064 13.6585 13.7218 13.0007 13.7218 12.1892ZM14.4418 12.1892C14.4418 13.3984 13.4617 14.3785 12.2525 14.3785C11.0433 14.3785 10.0632 13.3984 10.0632 12.1892C10.0632 10.98 11.0433 9.99987 12.2525 9.99987C13.4617 9.99987 14.4418 10.98 14.4418 12.1892ZM11.8925 8.35976H12.6125V8.89976H11.8925V8.35976ZM12.6125 8.89976C12.6125 9.37976 11.8925 9.37976 11.8925 8.89976V8.35976C11.8925 7.87975 12.6125 7.87975 12.6125 8.35976V8.89976ZM11.8925 15.6048H12.6125V16.1448H11.8925V15.6048ZM12.6125 16.1448C12.6125 16.6248 11.8925 16.6248 11.8925 16.1448V15.6048C11.8925 15.1248 12.6125 15.1248 12.6125 15.6048V16.1448ZM9.24546 9.75436L9.75458 9.24524L10.1365 9.6272L9.62742 10.1363L9.24546 9.75436ZM10.1365 9.6272C10.476 9.96661 9.96684 10.4757 9.62742 10.1363L9.24546 9.75436C8.90605 9.41494 9.41517 8.90582 9.75458 9.24524L10.1365 9.6272ZM14.3685 14.8773L14.8776 14.3682L15.2595 14.7502L14.7504 15.2593L14.3685 14.8773ZM15.2595 14.7502C15.599 15.0896 15.0898 15.5987 14.7504 15.2593L14.3685 14.8773C14.029 14.5379 14.5382 14.0288 14.8776 14.3682L15.2595 14.7502ZM8.36 12.6123V11.8923H8.90001V12.6123H8.36ZM8.90001 11.8923C9.38001 11.8923 9.38001 12.6123 8.90001 12.6123H8.36C7.88 12.6123 7.88 11.8923 8.36 11.8923H8.90001ZM16.145 11.8923C16.625 11.8923 16.625 12.6123 16.145 12.6123H15.605C15.125 12.6123 15.125 11.8923 15.605 11.8923H16.145ZM9.62744 14.3682C9.96685 14.0288 10.476 14.5379 10.1366 14.8773L9.7546 15.2593C9.41518 15.5987 8.90607 15.0896 9.24549 14.7502L9.62744 14.3682ZM14.7504 9.24522C15.0898 8.90581 15.599 9.41492 15.2595 9.75434L14.8776 10.1363C14.5382 10.4757 14.029 9.96659 14.3685 9.62717L14.7504 9.24522Z",
    fill: "#B5B510"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7197 25.4507L20.3749 19.625M23.6551 14.9243L22.9999 15.875",
    stroke: "#B5B510",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3535_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveManagement);
export default __webpack_public_path__ + "static/media/leave-management.ca68920a36afa80ec0b15deb0418d318.svg";
export { ForwardRef as ReactComponent };